import React from 'react';
import MarketServiceGenericService from "./MarketServiceGenericService";

function ChannelSourceService() {
    const endpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/channelSource/`;
    return (<MarketServiceGenericService
        endpointUrl={endpointUrl}
        pageName={"Channel Source Service"}
    />);
}

export default ChannelSourceService;